import { Form, Formik } from "formik";
import Select from "react-select";
import {
  getDefaultHandHeldFilters,
} from "./store/useHandHeldReaderCollectionStore";

const APPLY_BUTTON_STYLE = {
  backgroundColor: "#003366",
  color: "#FFFFFF",
  border: "none",
  fontWeight: 600,
  padding: "6px 16px",
  borderRadius: "6px",
  fontSize: "13px",
  whiteSpace: "nowrap",
};

const RESET_BUTTON_STYLE = {
  backgroundColor: "#FDE8E8",
  color: "#8B1A1A",
  border: "none",
  fontWeight: 600,
  padding: "6px 16px",
  borderRadius: "6px",
  fontSize: "13px",
  whiteSpace: "nowrap",
};

const HandHeldReaderCollectionFilter = ({
  initialValues = getDefaultHandHeldFilters(),
  wards = [],
  assetTypes = [],
  assetCategories = [],
  onAssetTypeChange,
  onSearch,
  onReset,
}) => (
  <Formik
    initialValues={initialValues}
    enableReinitialize
    onSubmit={(values) => onSearch?.(values)}
  >
    {({ values, setFieldValue, resetForm, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <label className="form-label">Ward</label>
            <Select
              inputId="circleId"
              name="circleId"
              classNamePrefix="react-select"
              options={wards.map((ward) => ({
                value: String(ward.circleId),
                label: ward.circleName,
              }))}
              value={
                wards
                  .map((ward) => ({
                    value: String(ward.circleId),
                    label: ward.circleName,
                  }))
                  .find(
                    (option) => option.value === String(values.circleId)
                  ) || null
              }
              onChange={(selected) =>
                setFieldValue("circleId", selected ? selected.value : "")
              }
              placeholder="Select Ward"
              isClearable
              menuPlacement="auto"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">Asset Type</label>
            <Select
              inputId="assetTypeId"
              name="assetTypeId"
              classNamePrefix="react-select"
              options={assetTypes.map((type) => ({
                value: String(type.assetTypeId ?? type.rfidTypeId ?? ""),
                label: type.assetTypeName ?? type.rfidTypeName,
              }))}
              value={
                assetTypes
                  .map((type) => ({
                    value: String(type.assetTypeId ?? type.rfidTypeId ?? ""),
                    label: type.assetTypeName ?? type.rfidTypeName,
                  }))
                  .find(
                    (option) => option.value === String(values.assetTypeId)
                  ) || null
              }
              onChange={(selected) => {
                const assetTypeId = selected ? selected.value : "";
                setFieldValue("assetTypeId", assetTypeId);
                setFieldValue("assetCategoryId", "");
                onAssetTypeChange?.(assetTypeId);
              }}
              placeholder="Select Asset Type"
              isClearable
              menuPlacement="auto"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">Asset Category</label>
            <Select
              inputId="assetCategoryId"
              name="assetCategoryId"
              classNamePrefix="react-select"
              options={assetCategories.map((category) => ({
                value: String(category.assetCategoryId),
                label: category.assetCategoryName,
              }))}
              value={
                assetCategories
                  .map((category) => ({
                    value: String(category.assetCategoryId),
                    label: category.assetCategoryName,
                  }))
                  .find(
                    (option) =>
                      option.value === String(values.assetCategoryId)
                  ) || null
              }
              onChange={(selected) =>
                setFieldValue(
                  "assetCategoryId",
                  selected ? selected.value : ""
                )
              }
              placeholder="Select Asset Category"
              isClearable
              menuPlacement="auto"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">From Date &amp; Time</label>
            <input
              type="datetime-local"
              name="fromDate"
              value={values.fromDate}
              onChange={(e) => setFieldValue("fromDate", e.target.value)}
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label className="form-label">To Date &amp; Time</label>
            <input
              type="datetime-local"
              name="toDate"
              value={values.toDate}
              min={values.fromDate || undefined}
              onChange={(e) => setFieldValue("toDate", e.target.value)}
              className="form-control bg-white"
            />
          </div>

          <div className="col-md-3 mb-3">
            <label
              className="form-label"
              aria-hidden="true"
              style={{ visibility: "hidden" }}
            >
              &nbsp;
            </label>
            <div className="d-flex gap-2">
              <button type="submit" style={APPLY_BUTTON_STYLE}>
                APPLY FILTERS
              </button>
              <button
                type="button"
                style={RESET_BUTTON_STYLE}
                onClick={() => {
                  const defaults = getDefaultHandHeldFilters();
                  resetForm({ values: defaults });
                  onReset?.();
                }}
              >
                RESET
              </button>
            </div>
          </div>
        </div>
      </Form>
    )}
  </Formik>
);

export default HandHeldReaderCollectionFilter;
